<ion-app *ngIf="{ status: networkStatus$ | async, modal: openModal$ | async }">
    <div *ngIf="isLoading$ | async" class="h-screen w-screen backdrop-blur-sm z-50">
        <ion-spinner class="fixed top-1/2 left-1/2 scale-[5]"></ion-spinner>
    </div>
    <ion-router-outlet></ion-router-outlet>

    <ion-modal [backdropDismiss]="false">
        <ng-template>
            <ion-content class="ion-padding">
                <div class="flex flex-col h-full">
                    <div class="flex flex-col h-1/2">
                        <div class="icon-stack">
                            <ion-icon class="primary" color="primary" name="wifi"></ion-icon>
                            <ion-icon class="secondary" color="primary" name="close-circle"></ion-icon>
                        </div>
                    </div>
                    <div class="flex justify-center">
                        <ion-text color="primary" class="text-center font-medium text-lg"> No internet connection </ion-text>
                    </div>
                    <div class="flex justify-center">
                        <ion-text class="text-center">Please check your internet settings</ion-text>
                    </div>
                </div>
            </ion-content>
        </ng-template>
    </ion-modal>
</ion-app>
